<template>
	<div id="centerWidth" :style="{'height':windowHeight+'px'}" style="overflow: auto;" @scroll="scrollEvent($event)">
		<div class="centerWidth" style="width: 1400px;">
			<div class="gaokao-nav">
				<span @click="goMyCenter">个人中心 ></span>
				<span>查.专业分数线</span>
			</div>
			<section class="gaokao-content">
				<article class="major-share">
					<ul>
						<li class="flex wrap">
							<label>科类：</label>
							<div class="fenNum_div">
								<p :class="isClassfiy == 0 ? 'on' : ''" @click="classFiyClick(0)">理科或选物理</p>
								<p :class="isClassfiy == 1 ? 'on' : ''" @click="classFiyClick(1)">文科或选历史</p>
								<p :class="isClassfiy == 2 ? 'on' : ''" @click="classFiyClick(2)">不分文理</p>
							</div>
						</li>
						<li class="flex wrap">
							<label>招生地区：</label>
							<div class="fenNum_div">
								<p :class="item.Name == currCityName ? 'on' : ''" @click="cityClick(item.Name)"
									v-for="(item, index) in cityList" :key="index">{{ item.Name }}</p>
							</div>
						</li>
					</ul>
					<div class="major-share-con">
						<div class="share-li">
							<p>专业名称:</p>
							<input placeholder="请输入专业名称" v-model="subjectName" />
						</div>
						<div class="major-btn01"><button class="gaokao-btn" @click="GetList(1)">搜索</button></div>
					</div>
				</article>
				<!-- 4.24表格 -->
				<div class="tbc_tabel">
					<div class="pptbiao">
						<!-- 01 -->
						<div class="ppthead flex">
							<div class="ppt_hli">
								<div class="ppt_hdd" style="width: 200px;">
									<p>{{columnName.CollegesNameStr}}</p>
								</div>
							</div>
							<div class="ppt_hli">
								<div class="ppt_hdd" style="width: 100px;">
									<p>{{columnName.CollegesAreaStr}}</p>
								</div>
							</div>
							<div class="ppt_hli">
								<div class="ppt_hdd" style="width: 80px;">
									<p>{{columnName.MajorCodeStr}}</p>
								</div>
							</div>
							<div class="ppt_hli">
								<div class="ppt_hdd" style="width: 188px;">
									<p>{{columnName.MajorNameStr}}</p>
								</div>
							</div>
							<div class="ppt_hli">
								<div class="ppt_hdd" style="width: 100px;">
									<p>{{columnName.EducationalStr}}</p>
								</div>
							</div>
							<div class="ppt_hli ppt_hlib" style="width: 80px;">
								<div class="ppt_hdd">
									<p>{{columnName.NewPlanStr}}</p>
								</div>
								<div class="ppt_hdd ppt_hdda">
									<p>{{columnName.CollegeYear}}</p>
								</div>
							</div>
							<div class="ppt_hli ppt_hlib" style="width: 228px;">
								<div class="ppt_hdd">
									<p>{{ columnName.YearsDateStr}}</p>
								</div>
								<div class="flex ppt_hddb">
									<div class="ppt_hdd ppt_hdda">
										<p>{{columnName.CollegeYear1}}</p>
									</div>
									<div class="ppt_hdd ppt_hdda">
										<p>{{columnName.CollegeYear2}}</p>
									</div>
									<div class="ppt_hdd ppt_hdda">
										<p>{{columnName.CollegeYear3}}</p>
									</div>
								</div>
							</div>
							<div class="ppt_hli">
								<div class="ppt_hdd" style="width: 93px;">
									<p>{{columnName.PreferredSubjectStr}}</p>
								</div>
							</div>
							<div class="ppt_hli">
								<div class="ppt_hdd" style="width: 93px;">
									<p>{{columnName.RequirementsSubjectsStr}}</p>
								</div>
							</div>
							<div class="ppt_hli">
								<div class="ppt_hdd" style="width: 93px;">
									<p>{{columnName.SolutionStr}}</p>
								</div>
							</div>
							<div class="ppt_hli">
								<div class="ppt_hdd" style="width: 93px;">
									<p>关注</p>
								</div>
							</div>
						</div>
						<!-- 02 -->
						<div class="pptnei_box" v-if="!isNoData">
							<ul>
								<li class="flex" v-for="(item, index) in list" :key="index">
									<div class="pptnei_li" style="width: 200px;">
										<div class="pptnei_view">
											<div class="name_div ptname_div " style="width: 100%;">
												<div class="flex zhong">
													<!-- color: #fa4237; -->
													<!-- <p style="width: calc(100% - 25px);cursor: pointer; " class="shl"
														@click="showColleges(item.CollegeProfile)">{{item.CollegesName}}
													</p>-->
													<p style="width: calc(100% - 25px);cursor: pointer; " class="shl"
														@click="showColleges(item.CollegeProfile)">{{item.CollegesName}}
													</p>
													<el-tooltip class="item" :content="item.CollegesName" effect="dark"
														placement="bottom">
														<img src="../../../image/shkl.png"
															style="width: 23px;height: 16px;margin-left: 0.5em;cursor: pointer;" />
													</el-tooltip>
												</div>
												<p>院校代码：{{item.CollegesCode}}</p>
												<p>院校类别：{{item.CollegesType}}</p>
												<p>院校类型：{{item.CollegesMold}}</p>
												<p>特色：{{item.Characte}}</p>
											</div>
										</div>
									</div>
									<div class="pptnei_li" style="width: 100px;">
										<div class="pptnei_view">
											<!-- color:#ff0000 -->
											<p style="color: #000 ;">{{item.CollegesArea}}</p>
										</div>
									</div>
									<div class="pptnei_li" style="width: 80px;">
										<div class="pptnei_view">
											<p style="color: #000 ;">{{item.MajorCode}}</p>
										</div>
									</div>
									<div class="pptnei_li" style="width: 188px;">
										<div class="pptnei_view">
											<div class="name_div ptname_div " style="width: 100%;">
												<div class="flex zhong">
													<!-- color: #fa4237; -->
													<p style="width: calc(100% - 25px);cursor: pointer; " class="shl"
														@click="setMajorName(item)">{{item.MajorName}}
													</p>
													<el-tooltip class="item" :content="item.MajorName" effect="dark"
														placement="bottom">
														<img src="../../../image/shkl.png"
															style="width: 23px;height: 16px;margin-left: 0.5em;cursor: pointer;" />
													</el-tooltip>
												</div>
											</div>
										</div>
									</div>
									<div class="pptnei_li" style="width: 100px;">
										<div class="pptnei_view">
											<div class="name_div ">
												<p style="color: #000 ;">
												<p>{{ item.Educational || '' }}{{ item.Tuition ? '/' + item.Tuition : '' }}
												</p>
												</p>
											</div>
										</div>
									</div>
									<div class="pptnei_li" style="width: 80px;">
										<div class="pptnei_view">
											<div class="name_div ">
												<p style="color: #000  !important;text-align:center !important;">
													{{ item.NewPlan||'' }}
												</p>
											</div>
										</div>
									</div>
									<div class="pptnei_li pptnei_liab" style="width: 228px;">
										<div class="pptnei_view  flex" style="width: 100%;">
											<div class="pptnei_fen">
												<div class="name_div " v-if="item.YearsDate1 && !item.isPop">
													<p>计划：{{ item.YearsDate1.NewPlan || '' }}</p>
													<p>平均分：{{ item.YearsDate1.Average || '' }}</p>
													<p>最低分：{{ item.YearsDate1.LowestScore || '' }}</p>
													<p>最低位次：{{ item.YearsDate1.LowestOrder || '' }}</p>
												</div>
												<div class="pptnei_li" style="height: 100%;" v-if="item.isPop">
													<div class="pptnei_view">
														<p>未招生</p>
													</div>
												</div>
											</div>
											<div class="pptnei_fen">
												<div class="name_div "
													v-if="item.YearsDate2&&item.YearsDate2.LowestScore">
													<p>计划：{{ item.YearsDate2.NewPlan || '' }}</p>
													<p>平均分：{{ item.YearsDate2.Average || '' }}</p>
													<p>最低分：{{ item.YearsDate2.LowestScore || '' }}</p>
													<p>最低位次：{{ item.YearsDate2.LowestOrder || '' }}</p>
												</div>
												<div class="pptnei_li" style="height: 100%;"
													v-if="(item.YearsDate2&&!item.YearsDate2.LowestScore) ||!item.YearsDate2">
													<div class="pptnei_view">
														<p>未招生</p>
													</div>
												</div>
											</div>
											<div class="pptnei_fen">
												<div class="name_div "
													v-if="item.YearsDate3&&item.YearsDate3.LowestScore">
													<p>计划：{{ item.YearsDate3.NewPlan || '' }}</p>
													<p>平均分：{{ item.YearsDate3.Average || '' }}</p>
													<p>最低分：{{ item.YearsDate3.LowestScore || '' }}</p>
													<p>最低位次：{{ item.YearsDate3.LowestOrder || '' }}</p>
												</div>
												<div class="pptnei_li" style="height: 100%;"
													v-if="(item.YearsDate3&&!item.YearsDate3.LowestScore)||!item.YearsDate3">
													<div class="pptnei_view">
														<p>未招生</p>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="pptnei_li" style="width: 93px;">
										<div class="pptnei_view">
											<div class="name_div ">
												<p style="color: #000  !important; text-align:center !important;">
													{{ item.PreferredSubject }}
												</p>
											</div>
										</div>
									</div>
									<div class="pptnei_li" style="width: 93px;">
										<div class="pptnei_view">
											<div class="name_div ">
												<p style="color: #000  !important; text-align:center !important;">
													{{ item.RequirementsSubjects }}
												</p>
											</div>
										</div>
									</div>
									<div class="pptnei_li" style="width: 93px;">
										<div class="pptnei_view" @click="goSolution(item.Solution)"
											v-if="item.Solution">
											<p><a target="_blank" style="text-align:center !important;">章程</a>
											</p>
										</div>
									</div>
									<div class="pptnei_li" style="width: 93px;">
										<div class="pptnei_view">
											<img :src="item.UserAttention ? require('../../../image/gz_aa.png') : require('../../../image/gz_a.png')"
												class="scImg" style="zoom: 0.7;" @click="CkeUserAttention(index)" />
										</div>
									</div>
								</li>
								<div class="ptend_gao">
									<div class=" ptend_div flexCenter" style="flex-direction: row;padding:15px 0;">
										<img src="../../../image/log.gif"
											style="width: 20px;height: 20px;margin-right: 12px; margin: 0;"
											v-if="BLoading" />
										<span style="margin-top: 0;">{{BLoading?'加载中':'加载已完成'}}</span>
									</div>
								</div>
							</ul>
						</div>
						<div class="ptend_gao" v-if="isNoData">
							<div class=" ptend_div">
								<img src="../../../image/empty.png" />
								<p>暂无数据</p>
							</div>
						</div>
					</div>
				</div>
			</section>
		</div>
		<!-- 院校 -->
		<aside class="popup flex zhong center" v-if="isYxPop">
			<div class="aside_pop" style="cursor:pointer;">
				<div class="aside_height" v-if="yxList.length>0">
					<ul>
						<li v-for="(item, index) in yxList" :key="index" @click="setCollegeName(item)">
							{{item.Name}}
						</li>
					</ul>
				</div>
				<div class="ptend_gao" v-else>
					<div class=" ptend_div">
						<img src="../../../image/empty.png" />
						<p>暂无数据</p>
					</div>
				</div>
				<div class="aside_btn flex zhong center"><button class="zhun_btn" @click="isYxPop = false">关闭</button>
				</div>
			</div>
		</aside>
		<!-- 专业 -->
		<aside class="popup flex zhong center" v-if="isZyPop">
			<div class="aside_pop" style="cursor:pointer;">
				<div class="aside_height" v-if="zyList.length>0">
					<ul>
						<li v-for="(item, index) in zyList" :key="index" @click="setMajorName(item)">
							{{item.MajorName}}
						</li>
					</ul>
				</div>
				<div class="ptend_gao" v-else>
					<div class=" ptend_div">
						<img src="../../../image/empty.png" />
						<p>暂无数据</p>
					</div>
				</div>
				<div class="aside_btn flex zhong center"><button class="zhun_btn" @click="isZyPop = false">关闭</button>
				</div>
			</div>
		</aside>
		
		<aside class="popup flexCenter" v-if="isZhuan">
			<div class="ptzhuan_bai">
				<img src="../../../image/vol-del-t.png" @click="isZhuan = false" />
				<div class="ptzhuan_h6">选择专业</div>
				<div style="height: 400px;overflow: auto;" v-if="zhuanList.length>0">
					<div class="ptzhuan_list flex wrap">
						<p :title="item.Name" v-for="(item, index) in zhuanList" :key="index"
							@click="goMajorInfo(item.Id)">{{ item.Name }}</p>
					</div>
				</div>
				<div class="ptend_gao" v-else>
					<div class=" ptend_div">
						<img src="../../../image/empty.png" />
						<p>暂无数据</p>
					</div>
				</div>
			</div>
		</aside>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				isZhuan:false,
				zhuanList:[],
				ZyNoData:false,
				// 院校
				isYxPop: false,
				yxList: [],
				// 专业
				isZyPop: false,
				zyList: [],
				isNoData: false,
				BLoading: true,
				columnName: {},
				isClassfiy: 2,
				isCity: 0,
				cityList: [],
				subjectName: '',
				totleNum: 0,
				page: 1,
				pageSize: 10,
				list: [],
				currCityName: '',
				candidatesType: '不分文理',
				windowHeight: document.documentElement.clientHeight,
				isPage: false
			};
		},
		// 加载
		created() {
			if (this.$route.query.key) {
				this.$api.reduceUserCount({
					key: this.$route.query.key
				});
			} else {
				this.$router.back(-1);
			}
			this.$store.state.shop.currentProvince.map(ent => {
				if (ent.Code === this.$store.state.user.user.ProvinceCode.toString()) {
					this.cityList.push(ent);
				}
			});
			this.getColumnName();
			this.GetList(1);
		},
		watch: {
			windowHeight(val) {
				const that = this;
				console.log('实时屏幕高度：', val, that.windowHeight);
			}
		},
		mounted() {
			const that = this;
			window.onresize = () => {
				return (() => {
					window.fullHeight = document.documentElement.clientHeight;
					that.windowHeight = window.fullHeight;
				})();
			};
		},
		methods: {
			scrollEvent(e) {
				var that = this;
				var scrollBottom = e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight;
				// console.log('滚动', scrollBottom);
				if (scrollBottom < 10) {
					if (that.isPage) {
						console.log('翻页');
						that.isPage = false;
						var pg = that.page + 1;
						that.GetList(pg);
					}
				}
			},
			// 获取表头名
			async getColumnName() {
				const res = await this.$api.getColumnName();
				this.columnName = res.data;
			},
			// 个人中心
			goMyCenter() {
				this.$router.push('/myIndex');
			},
			showColleges(list){
				console.log('院校',list);
				this.yxList = list;
				this.isYxPop = true;
			},
			classFiyClick(index) {
				this.isClassfiy = index;
				this.candidatesType = index === 0 ? '理科' : index === 1 ? '文科' : '不分文理';
				
				this.GetList(1);
			},
			setCollegeName(item){
				window.open(`${window.location.origin}${window.location.pathname}#/schoolinfo?schoolname=${item.Name}`);
			},
			cityClick(name) {
				if (this.currCityName === name) {
					this.currCityName = '';
				} else {
					this.currCityName = name;
				}
			},
			// 获取代理城市
			GetCity: function() {
				var that = this;
				that.$api.HtppRequest(
					'SystemData/GetShopCity',
					'GET', {},
					function(res) {
						console.log('获取代理城市');
						console.log(res);
						if (res.flag) {
							that.cityList = res.list;
						}
					},
					function(err) {
						console.log(err);
					}
				);
			},
			// 获取列表
			GetList: function(page) {
				var that = this;
				const loading = this.$loading({
				  lock: true,
				  text: 'Loading',
				  spinner: 'el-icon-loading',
				  background: 'rgba(0, 0, 0, 0.7)'
				});
				that.BLoading = true;
				that.isNoData = false;
				that.$api.HtppRequest(
					'Accurate/GetProfession',
					'POST', {
						page: page,
						pageSize: 10,
						selectMajorNames: that.subjectName,
						searchCitysCode: that.currCityName,
						CandidatesType: that.candidatesType
					},
					function(res) {
						console.log('获取列表', res);
						if(page==1){
							that.list =[];
						}
						if (res.code === 0) {
							if (res.data.length > 0) {
								that.list = that.list.concat(res.data);
								that.page = page;
								console.log(that.list);
							}
							that.isPage = true;
							that.totleNum = res.totalCount;
						}
						that.BLoading = false;
						that.isNoData = that.list.length==0;
						loading.close();
					},
					function(err) {
						that.BLoading = false;
						that.isNoData = that.list.length==0;
						loading.close();
						console.log(err);
					}
				);
			},
			// 获取其他页
			GetPageList: function(val) {
				var that = this;
				that.GetList(val);
				console.log(`当前页: ${val}`);
			},
			showMajorList(rows) {
				var that = this;
				console.log('院校', rows);
				// 2022-04-22 17:10 与张燕确认接口年份取计划的年份-1
				console.log('111111111111', rows.CollegesCode, rows.CollegesType, rows.CollegesName, rows);
				that.$api.HtppRequest(
					'SystemData/GetProfessionaScoreByColleges?cityCode=&collegesCode=' +
					rows.CollegesCode +
					'&candidatesType=' +
					rows.CollegesType +
					'&collegesName=' +
					rows.CollegesName +
					'&year=' +
					(rows.NewYear?parseInt(rows.NewYear) - 1:''),
					'GET', {},
					function(res) {
						if (res.flag) {
							that.zyList = res.list;
							that.isZyPop = true;
						}
					},
					function(err) {
						console.log(err);
					}
				);
			},
			setMajorName(item) {
				this.zhuanList = item.MajorProfile;
				this.ZyNoData = this.zhuanList.length === 0;
				this.isZhuan = true;
			},
			// 前往专业详情页
			goMajorInfo(id) {
				window.open(`${window.location.origin}${window.location.pathname}#/majorinfo?Id=${id}`);
			}
		}
	};
</script>

<style scoped>
	.aside_height li {
		border-bottom: solid 1px #eeeeee;
		padding: 14px 0;
		text-indent: 1em;
		font-size: 14px;
		color: #666666;
	}

	.aside_height {
		height: 320px;
		overflow-y: auto;
		border-radius: 6px;
		border: solid 1px #eeeeee;
	}

	.zhun_btn.on {
		background-color: #005371;
	}

	.zhun_btn {
		width: 120px;
		height: 40px;
		background-color: #666;
		border-radius: 4px;
		font-size: 14px;
		color: #fff;
		line-height: 40px;
		margin-right: 20px;
		display: block;
		cursor: pointer;
	}

	.zhun_btn:last-child {
		margin-right: 0;
	}

	.aside_btn .zhun_btn {
		background-color: #333;
		border: solid 1px #333;
	}

	.aside_btn .zhun_btn:first-child {
		background-color: #fff;
		color: #333;
		border: solid 1px #333;
	}

	.aside_btn {
		margin-top: 40px;
	}

	.aside_box {
		width: 70%;
		margin: 0 10px;
	}

	.aside_div {
		width: 90%;
		margin: 0 auto;
	}

	.aside_pop {
		width: 520px;
		border-radius: 10px;
		background-color: #fff;
		padding: 50px 20px 20px 20px;
	}

	/* aside_pop */

	.span-win {
		padding-left: 30px;
	}

	.table li p {
		font-size: 14px;
		width: calc(100% / 6);
		line-height: 60px;
		text-align: center;
	}

	.table li:last-child {
		border-bottom: none;
	}

	.table li p:last-child {
		border-right: none;
	}

	.table li {
		border-bottom: solid 1px #e6e6e6;
	}

	.table ul {
		overflow: hidden;
	}

	.table hgroup p {
		font-size: 14px;
		background-color: #eaeaea;
		width: calc(100% / 6);
		line-height: 60px;
		text-align: center;
	}

	.table {
		overflow: hidden;
		border: solid 1px #e6e6e6;
		box-sizing: border-box;
	}

	/* 01 */
	.fenNum_div p {
		width: 115px;
		height: 40px;
		line-height: 40px;
		float: left;
		color: #333;
		font-size: 14px;
		margin-right: 5px;
		text-align: center;
		border-radius: 4px;
		cursor: pointer;
	}

	.fenNum_div p:hover {
		opacity: 0.7;
	}

	.fenNum_div p.on:hover {
		opacity: 1;
	}

	.fenNum_div p.on {
		background-color: #333;
		color: #fff;
	}

	.fenNum_div {
		width: calc(100% - 200px);
		margin-left: 20px;
	}

	.major-share label {
		font-size: 14px;
		color: #333;
		display: block;
		width: 100px;
		line-height: 40px;
		text-align: right;
	}

	.major-share ul li:first-child {
		margin-top: 0;
	}

	.major-share ul li {
		margin-top: 10px;
	}

	.major-share ul {
		overflow: hidden;
	}

	/* major-share */

	.gaokao-btn {
		width: 90px;
		font-size: 14px;
		margin-left: 0 !important;
	}

	.fenNum_head p.on {
		background-color: #333;
		color: #fff;
	}

	.fenNum_head p.on:hover {
		opacity: 1;
	}

	.fenNum_head p {
		font-size: 16px;
		color: #333;
		width: 180px;
		height: 38px;
		border-top-left-radius: 4px;
		border-top-right-radius: 4px;
		float: left;
		border: solid 1px #333;
		border-bottom: none;
		text-align: center;
		line-height: 38px;
		cursor: pointer;
	}

	.fenNum_head p:hover {
		opacity: 0.7;
	}

	.fenNum_head {
		overflow: hidden;
		border-bottom: solid 2px #333;
		margin-top: 40px;
	}

	/* fenNum_head */

	.gaokao-nav {
		width: 100%;
		display: flex;
		align-items: center;
		padding: 20px 0;
	}

	.gaokao-nav span {
		font-size: 15px;
		color: #333;
	}

	.gaokao-nav span:last-child {
		color: #333;
	}

	/* gaokao-content */
	.gaokao-content {
		padding: 0 20px;
		width: 100%;
		height: auto;
		overflow: hidden;
		background-color: #fff;
		margin-bottom: 25px;
	}

	/* major-share */
	.major-share {
		width: 100%;
		height: auto;
		overflow: hidden;
		background-color: #eaeaea;
		margin: 20px auto 30px auto;
		padding: 30px 0;
	}

	.major-share-con {
		width: 75%;
		height: auto;
		overflow: ;
		display: flex;
		flex-wrap: wrap;
	}

	.share-li {
		width: 50%;
		display: flex;
		align-items: center;
		/* justify-content: center; */
		margin: 10px 0;
	}

	.share-li p {
		font-size: 14px;
		color: #333;
		width: 100px;
		text-align: right;
		margin-right: 20px;
	}

	.share-li input {
		width: 270px;
		height: 40px;
		line-height: 40px;
		padding: 0 10px;
		display: block;
		border-radius: 5px;
		background-color: #fff;
		color: #333;
		font-size: 14px;
	}

	.share-li input::-webkit-input-placeholder {
		color: #999;
	}

	.share-li input:-moz-placeholder {
		color: #999;
	}

	.share-li input:-ms-input-placeholder {
		color: #999;
	}

	.sjWidth {
		width: 270px;
	}

	.major-btn01 {
		width: 25%;
		display: flex;
		align-items: flex-end;
	}

	.major-btn01 button {
		margin: 10px auto;
	}

	/* major-list */
	.major-list {
		width: 100%;
		height: auto;
		margin-top: 15px;
	}

	.major-list ul {
		width: 100%;
		height: auto;
	}

	.major-list ul li {
		border: 1px solid #eee;
		width: 100%;
		height: auto;
		padding: 20px 30px;
		margin-bottom: 20px;
		position: relative;
	}

	.major-li01 {
		width: 100%;
		height: auto;
		display: flex;
		align-items: center;
	}

	.major-li-btn {
		width: 20%;
	}

	.major-li-btn p {
		width: 130px;
		height: 33px;
		line-height: 33px;
		text-align: center;
		background-color: #333;
		font-size: 16px;
		color: #fff;
		border-radius: 50px;
	}

	.major-li01-right {
		width: 80%;
		display: flex;
	}

	.major-li01-right p {
		width: 20%;
		display: flex;
		align-items: center;
		line-height: 33px;
	}

	.major-li01-right p span {
		font-size: 15px;
		color: #999;
	}

	.major-li01-right p span:last-child {
		color: #333;
	}

	.major-li02 {
		display: flex;
		align-items: center;
		margin-bottom: 10px;
	}

	.major-li02 p {
		font-size: 14px;
	}

	.major-txt01 {
		width: 75px;
		color: #999;
	}

	.major-txt02 {
		width: calc(100% - 120px);
		color: #333;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.major-more {
		width: 45px;
		color: #333;
		text-align: right;
		cursor: pointer;
	}

	.major-txt04 {
		color: #333;
	}

	.major-more-con {
		position: absolute;
		width: 98%;
		height: auto;
		background: rgba(0, 0, 0, 0.7);
		padding: 20px;
		font-size: 15px;
		color: #fff;
		left: 1%;
		bottom: 0;
		border-radius: 5px;
		margin-bottom: -14px;
		z-index: 1;
	}

	.major-more-con::after {
		position: absolute;
		content: '';
		right: 0;
		top: 0;
		width: 0;
		height: 0;
		border-left: 8px solid transparent;
		border-right: 8px solid transparent;
		border-bottom: 14px solid rgba(0, 0, 0, 0.7);
		margin-top: -14px;
		margin-right: 24px;
	}

	.major-page {
		margin-bottom: 30px;
	}

	.widthx {
		margin-top: 20px;
		margin-bottom: 10px;
	}

	.widthx .major-li01-right {
		width: 100%;
	}

	.widthx .major-li01-right p:first-child {
		min-width: 22.2%;
	}

	.widthx .major-li01-right p:nth-child(2) {
		width: 32.3%;
	}

	.lastIndex .major-li01-right p {
		width: 35%;
	}

	/* 1 */
	.zhun_btn.on {
		background-color: #005371;
	}

	.zhun_btn {
		width: 120px;
		height: 40px;
		background-color: #666;
		border-radius: 4px;
		font-size: 14px;
		color: #fff;
		line-height: 40px;
		margin-right: 20px;
		display: block;
		cursor: pointer;
	}

	.zhun_btn:last-child {
		margin-right: 0;
	}

	.aside_btn .zhun_btn {
		background-color: #333;
		border: solid 1px #333;
	}

	.aside_btn .zhun_btn:first-child {
		background-color: #fff;
		color: #333;
		border: solid 1px #333;
	}

	.aside_btn {
		margin-top: 40px;
	}

	.aside_box {
		width: 70%;
		margin: 0 10px;
	}

	.aside_div {
		width: 90%;
		margin: 0 auto;
	}

	.aside_pop {
		width: 520px;
		border-radius: 10px;
		background-color: #fff;
		padding: 50px 20px 20px 20px;
	}

	/* aside_pop */
	/* 01 */
	.aside_height li {
		border-bottom: solid 1px #eeeeee;
		padding: 14px 0;
		text-indent: 1em;
		font-size: 14px;
		color: #666666;
	}

	.aside_height {
		height: 320px;
		overflow-y: auto;
		border-radius: 6px;
		border: solid 1px #eeeeee;
	}

	.tbc_tabel.active /deep/.el-table--border td {
		background-color: #fff4ee;
	}

	/deep/.el-table thead.is-group th {
		background-color: #bddcf6;
	}

	/deep/.el-table--border td {
		background-color: #ddebf7;
	}

	.name_div>p {
		font-size: 12px !important;
		color: #999 !important;
		text-align: left !important;
	}

	.name_div>p span {
		color: #666 !important;
	}

	.table img.scImg {
		display: block;
		width: 20px;
		height: 20px;
		margin: 0 auto;
		cursor: pointer;
	}

	.table p {
		text-align: center;
		font-size: 14px;
		font-weight: normal;
		color: #333;
	}

	/deep/.el-table td,
	/deep/.el-table th {
		padding: 5px 0 !important;
	}

	/deep/.cell {
		text-align: center;
		font-size: 14px;
		font-weight: normal;
		color: #333;
	}

	.table p span {
		font-size: 14px;
		color: #333;
		padding-bottom: 8px;
		border-bottom: solid 1px #333;
		line-height: initial;
		margin: 0 10px;
		cursor: pointer;
	}

	.table li p {
		font-size: 14px;
		width: calc(100% / 6);
		line-height: 60px;
		text-align: center;
		color: #666666;
	}

	.table li:last-child {
		border-bottom: none;
	}

	.table li p:last-child {
		border-right: none;
	}

	.table li {
		border-bottom: solid 1px #e6e6e6;
	}

	.table ul {
		overflow: hidden;
	}

	.table hgroup p {
		font-size: 14px;
		background-color: #eaeaea;
		width: calc(100% / 6);
		line-height: 60px;
		text-align: center;
	}

	.table {
		overflow: hidden;
		border: solid 1px #e6e6e6;
		box-sizing: border-box;
	}

	.zypt {
		display: inline-block;

		border-bottom: solid 1px #94918f;
		cursor: pointer;
	}
</style>
